import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=4027044d&scoped=true&"
import script from "./MainNav.vue?vue&type=script&lang=ts&"
export * from "./MainNav.vue?vue&type=script&lang=ts&"
import style0 from "./MainNav.vue?vue&type=style&index=0&id=4027044d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027044d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JobPostAuthButton: require('/root/project/frontend/src/components/navigation/JobPostAuthButton.vue').default,UserMenu: require('/root/project/frontend/src/components/navigation/UserMenu.vue').default,AuthMobileUserMenu: require('/root/project/frontend/src/components/navigation/main/AuthMobileUserMenu.vue').default,SignButtons: require('/root/project/frontend/src/components/navigation/SignButtons.vue').default,UserUnAuthMobile: require('/root/project/frontend/src/components/navigation/main/UserUnAuthMobile.vue').default,AuthStatus: require('/root/project/frontend/src/components/AuthStatus.vue').default})
